StaffMember = require 'models/staff-member'
Account = require 'models/account'

isDisabledBy = (transport) ->
  Em.computed 'notification.event_type', ->
    type = @get('notification.event_type')
    _.any Account.DISABLED_NOTIFICATIONS, (n) ->
      (n[0] is type) and (n[1] is transport)

App.StaffNotificationComponent = Em.Component.extend
  env: Em.inject.service('environment')

  tagName: 'tr'

  notification: null
  staff: null

  disabledSms:   isDisabledBy('sms')
  disabledFaye:  isDisabledBy('faye')
  disabledUrl:   isDisabledBy('url')
  disabledEmail: isDisabledBy('email')

  translatedEvent: (->
    @get('env').translate("staff.notifications.#{ @get('notification.event_type') }")
  ).property('notification.event_type')
